module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 _.each(positions, function(position, pos_id) { 
__p+='\n\n<div class="line-heading">\n	'+
((__t=( _.result(position, 'plural', {}) ))==null?'':_.escape(__t))+
'\n</div>\n<div class="lineup-players">\n\n	<div class="line-players">\n	';
 _.each(home.lineup_players[pos_id] , function(player) { 
__p+='\n		';
 if (!player.id) { 
__p+='\n		<div class="player home no-player">\n			<div class="pos '+
((__t=( player.leader_class_name ))==null?'':_.escape(__t))+
'">\n				<div  class="field-position-label">\n					<span>\n						'+
((__t=( position.short_name ))==null?'':_.escape(__t))+
''+
((__t=( player.bench_pos_name ))==null?'':_.escape(__t))+
'\n					</span>\n					';
 if (player.bench_index) { 
__p+='\n					<i class="bench-index">'+
((__t=( player.bench_index ))==null?'':_.escape(__t))+
'</i>\n					';
 } 
__p+='\n				</div>\n			</div>\n			<div class="data">\n				<figure>\n					<picture>\n						<source srcset="/assets/images/player-icon.webp" type="image/webp" />\n						<img src="/assets/images/prizes/player-icon.jpg" alt="Player Icon" />\n					</picture>\n				</figure>\n				<div class="player-info">\n					'+
((__t=( no_player_message ))==null?'':_.escape(__t))+
'\n				</div>\n\n			</div>\n		</div>\n		';
 } else { 
__p+='\n\n		<div class="js-toggle-player-modal player home '+
((__t=( player.is_dnp ? 'is-dnp' : '' ))==null?'':_.escape(__t))+
' '+
((__t=( player.is_not_counted ? 'is-not-counted' : '' ))==null?'':_.escape(__t))+
'" data-player-id='+
((__t=( player.id ))==null?'':_.escape(__t))+
'\n			data-player-is-locked='+
((__t=( player.is_locked ))==null?'':_.escape(__t))+
'>\n			<div class="pos '+
((__t=( player.leader_class_name ))==null?'':_.escape(__t))+
'">\n				<div  class="field-position-label">\n					<span>\n						'+
((__t=( position.short_name ))==null?'':_.escape(__t))+
''+
((__t=( player.bench_pos_name ))==null?'':_.escape(__t))+
'\n					</span>\n					';
 if (player.bench_index) { 
__p+='\n					<i class="bench-index">'+
((__t=( player.bench_index ))==null?'':_.escape(__t))+
'</i>\n					';
 } 
__p+='\n				</div>\n			</div>\n			<div class="data">\n				<figure>\n					<picture>\n						<source	srcset="'+
((__t=( _.getPlayerAvatarUrl({ id: player.id, size: 100, format:'webp' }) ))==null?'':_.escape(__t))+
'" type="image/webp" />\n						<img src="'+
((__t=( _.getPlayerAvatarUrl({ id: player.id, size: 100 }) ))==null?'':_.escape(__t))+
'"\n						     alt="'+
((__t=( player.first_name + ' ' + player.last_name ))==null?'':_.escape(__t))+
'">\n					</picture>\n				</figure>\n\n				<div class="player-info">\n					<div class="player-name">\n						';
 if(round_info.status != "complete") { 
__p+='\n							<i class="icon player-status '+
((__t=( player.status ))==null?'':_.escape(__t))+
'"></i>\n						';
 } 
__p+='\n						<span>'+
((__t=( player.first_name[0] ))==null?'':_.escape(__t))+
'. '+
((__t=( player.last_name ))==null?'':_.escape(__t))+
'</span>\n					</div>\n\n					<div class="player-stats">\n						<span class="player-opponent">\n							<b>'+
((__t=( player.squad.short_name ))==null?'':_.escape(__t))+
'</b> '+
((__t=( player.opponents.symbol ))==null?'':_.escape(__t))+
' '+
((__t=( player.opponent.short_name ))==null?'':_.escape(__t))+
'\n						</span>\n						<span> | </span>\n						<span class="player-positions">\n							'+
((__t=( player.position_names.join(', ') ))==null?'':_.escape(__t))+
'\n						</span>\n					</div>\n				</div>\n			</div>\n\n			<div class="player-score">\n				<span class="'+
((__t=( player.is_playing_now && player.stats.points_last_round ? 'is-scoring-now' : '' ))==null?'':_.escape(__t))+
'">'+
((__t=( player.stats.points_last_round ))==null?'':_.escape(__t))+
'</span>\n				';
 if (!_.isUndefined(player.stats.proj_score) && player.stats.points_last_round === '') { 
__p+='\n				<span class="projected">\n					'+
((__t=( _.result(player, 'stats.proj_score') ))==null?'':_.escape(__t))+
'\n				</span>\n				';
 } 
__p+='\n			</div>\n		</div>\n		';
 } 
__p+='\n	';
 }) 
__p+='\n	</div>\n\n	<div class="line-players">\n		';
 _.each(away.lineup_players[pos_id] , function(player) { 
__p+='\n			';
 if (!player.id) { 
__p+='\n			<div class="player away no-player">\n				<div class="pos '+
((__t=( player.leader_class_name ))==null?'':_.escape(__t))+
'">\n					<div  class="field-position-label">\n					<span>\n						'+
((__t=( position.short_name ))==null?'':_.escape(__t))+
''+
((__t=( player.bench_pos_name ))==null?'':_.escape(__t))+
'\n					</span>\n						';
 if (player.bench_index) { 
__p+='\n						<i class="bench-index">'+
((__t=( player.bench_index ))==null?'':_.escape(__t))+
'</i>\n						';
 } 
__p+='\n					</div>\n				</div>\n				<div class="data">\n\n					<div class="player-info">\n						'+
((__t=( no_player_message ))==null?'':_.escape(__t))+
'\n					</div>\n					<figure>\n						<picture>\n							<source srcset="/assets/images/player-icon.webp" type="image/webp" />\n							<img src="/assets/images/prizes/player-icon.jpg" alt="Player Icon" />\n						</picture>\n					</figure>\n				</div>\n			</div>\n			';
 } else { 
__p+='\n			<div class="js-toggle-player-modal player away '+
((__t=( player.is_dnp ? 'is-dnp' : '' ))==null?'':_.escape(__t))+
' '+
((__t=( player.is_not_counted ? 'is-not-counted' : '' ))==null?'':_.escape(__t))+
'" data-player-id='+
((__t=( player.id ))==null?'':_.escape(__t))+
'>\n				<div class="player-score">\n					<span class="'+
((__t=( player.is_playing_now && player.stats.points_last_round ? 'is-scoring-now' : '' ))==null?'':_.escape(__t))+
'">'+
((__t=( player.stats.points_last_round ))==null?'':_.escape(__t))+
'</span>\n					';
 if (!_.isUndefined(player.stats.proj_score) && player.stats.points_last_round === '') { 
__p+='\n					<span class="projected">\n						'+
((__t=( _.result(player, 'stats.proj_score') ))==null?'':_.escape(__t))+
'\n					</span>\n					';
 } 
__p+='\n				</div>\n				<div class="data">\n\n\n					<div class="player-info">\n						<div class="player-name">\n							';
 if(round_info.status != "complete") { 
__p+='\n								<i class="icon player-status '+
((__t=( player.status ))==null?'':_.escape(__t))+
'"></i>\n							';
 } 
__p+='\n							<span>'+
((__t=( player.first_name[0] ))==null?'':_.escape(__t))+
'. '+
((__t=( player.last_name ))==null?'':_.escape(__t))+
'</span>\n						</div>\n\n						<div class="player-stats">\n							<span class="player-opponent">\n								<b>'+
((__t=( player.squad.short_name ))==null?'':_.escape(__t))+
'</b> '+
((__t=( player.opponents.symbol ))==null?'':_.escape(__t))+
' '+
((__t=( player.opponent.short_name ))==null?'':_.escape(__t))+
'\n							</span>\n							<span> | </span>\n							<span class="player-positions">\n								'+
((__t=( player.position_names.join(', ') ))==null?'':_.escape(__t))+
'\n							</span>\n\n						</div>\n					</div>\n\n					<figure>\n						<picture>\n							<source	srcset="'+
((__t=( _.getPlayerAvatarUrl({ id: player.id, size: 100, format:'webp' }) ))==null?'':_.escape(__t))+
'" type="image/webp" />\n							<img src="'+
((__t=( _.getPlayerAvatarUrl({ id: player.id, size: 100 }) ))==null?'':_.escape(__t))+
'"\n							     alt="'+
((__t=( player.first_name + ' ' + player.last_name ))==null?'':_.escape(__t))+
'">\n						</picture>\n					</figure>\n\n				</div>\n\n				<div class="pos '+
((__t=( player.leader_class_name ))==null?'':_.escape(__t))+
'">\n					<div  class="field-position-label">\n						<span>\n							'+
((__t=( position.short_name ))==null?'':_.escape(__t))+
''+
((__t=( player.bench_pos_name ))==null?'':_.escape(__t))+
'\n						</span>\n						';
 if (player.bench_index) { 
__p+='\n						<i class="bench-index">'+
((__t=( player.bench_index ))==null?'':_.escape(__t))+
'</i>\n						';
 } 
__p+='\n					</div>\n				</div>\n			</div>\n			';
 } 
__p+='\n		';
 }) 
__p+='\n	</div>\n</div>\n';
 }) 
__p+='\n<div class="js-player-popup"></div>';
}
return __p;
};
